import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletConnectComponent } from '../../components/wallet-connect/wallet-connect.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from '../../components/dropdown/dropdown.component.module';
import { QRScanner } from '@ionic-native/qr-scanner/ngx';
import { QrcodeModule } from '../../components/qrcode/qrcode.module';
import { FormsModule } from '@angular/forms';
import { QrScannerModule } from '../../components/browser-scanner/browser-scanner.module';
import { TransactionHistoryMoralisModule } from '../../components/transaction-history-moralis/transaction-history-moralis.module';
import { ModalDisclaimerComponent } from 'src/app/components/wallet-connect/disclaimer-modal/disclaimer-modal.component';
import { ScannerModule } from 'src/app/components/browser-scanner/scanner/scanner.module';

const routes: Routes = [
  {
    path: '',
    component: WalletConnectComponent,
  },
];

@NgModule({
  declarations: [WalletConnectComponent, ModalDisclaimerComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule,
    DropdownModule,
    QrcodeModule,
    FormsModule,
    QrScannerModule,
    TransactionHistoryMoralisModule,
    ScannerModule
  ],
  providers: [QRScanner],
})
export class WalletConnectModule {}
